import { Button } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useContext } from 'react';
import { Buscador } from '../Pedido/Buscador';
import { MasterContext } from '../../context/MasterContext';
import { UserContext } from '../../context/UserProvider';
import MerchandisingButton from './MerchandisingButton';
import { Colxx } from '../../components/common/CustomBootstrap';
import ManualUsoButton from './ManualUsoButton';
import { handleChangeInputSearch, handleClearInput, handleKeyDown } from '../../helpers/buscadorHelper';
import ExportImportArticles from '../ExportImportArticles';

export const HeaderMaster = ({ handleClicAddArte }) => {
  const { setInputValueSearch, inputAfter, setInputAfter } = useContext(MasterContext);
  const { userRole } = useContext(UserContext);

  return (
    <div className="header-container">
      <Colxx xxs="12" className="remove-margin-padding">
        <h2 className="font-size-1-resonsive">CATÁLOGO DE MATERIALES</h2>
      </Colxx>

      <Colxx className="df-jcsb remove-margin-padding article-searcher-w-buttons">
        <Buscador
          label="Buscar por nombre, por código de ariba, por palabra clave..."
          value={inputAfter}
          width={'40'}
          onChange={(e) => handleChangeInputSearch(e, setInputAfter)}
          onKeyDown={(e) => handleKeyDown(e, setInputValueSearch)}
          onClear={() => handleClearInput(setInputValueSearch, setInputAfter)}
        />
        {userRole === 'MasterAdmin' ? (
          <div className="articles-section-buttons">
            <ManualUsoButton path={'/manual-master/doc'} />
            <MerchandisingButton />
            <div className="articles-section-last-button">
              <ExportImportArticles />
              <Button
                size="small"
                variant="contained"
                color="error"
                startIcon={<AddCircleOutlineIcon />}
                onClick={handleClicAddArte}
              >
                Artículo
              </Button>
            </div>
          </div>
        ) : (
          <span />
        )}
      </Colxx>
    </div>
  );
};
